import { render, staticRenderFns } from "./MatchSignupContestantConfigEdit.vue?vue&type=template&id=3363fc60&"
import script from "./MatchSignupContestantConfigEdit.vue?vue&type=script&lang=js&"
export * from "./MatchSignupContestantConfigEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports